/** @format */

import PairingModelParameterInputComponent from './pairing-model.parameterInput.component';
import DutiesVisualization from './pairing-model.visualization.component';
import PairingModelDeatilsView from './pairing-model.details.component';
import SankeyChartComponent from './pairing-model.sankey-chart.component';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { deepmerge } from '@mui/utils';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';

import { useState } from 'react';

const options = [
  '🚀 Pairing Model Inputs',
  '📈 Duties Gantt Viz',
  'Details View',
  '📈 Sankey Chart',
];
const PairingModelComponent = () => {
  return (
    <>
      <ScopedCssBaseline>
        <Container
          maxWidth={false}
          sx={{
            minWidth: '95vw',
          }}
        >
          <FullWidthTabs />
        </Container>
      </ScopedCssBaseline>
    </>
  );
};

export default PairingModelComponent;

export const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#b71c1c',
    },
    secondary: {
      main: '#e0e0e0',
    },
    warning: {
      main: '#ff9100',
    },
  },
};
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

function FullWidthTabs({ setModalOpen, setModalText, setModalLoading }) {
  // let theme = useTheme();
  let theme = createTheme(deepmerge(themeOptions));
  const [value, setValue] = useState(0);

  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ bgcolor: 'background.paper', overflowX: 'scroll' }}>
        <AppBar sx={{ bgcolor: 'background.paper' }} position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            {options.map((option, index) => {
              return (
                <Tab
                  key={option + index}
                  label={option}
                  {...a11yProps(index)}
                />
              );
            })}
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={value}
          onChangeIndex={handleChangeIndex}
        >
          <TabPanel value={value} index={0} dir={theme.direction}>
            <PairingModelParameterInputComponent />
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction}>
            <DutiesVisualization />
          </TabPanel>
          <TabPanel value={value} index={2} dir={theme.direction}>
            <PairingModelDeatilsView />
          </TabPanel>
          <TabPanel value={value} index={3} dir={theme.direction}>
            <SankeyChartComponent />
          </TabPanel>
        </SwipeableViews>
      </Box>
    </ThemeProvider>
  );
}
